import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import _ from 'lodash';
import { Doughnut } from 'react-chartjs-2';

export default function GenderRatio() {
  const data = useStaticQuery(graphql`
    query {
      allEpisodesJson {
        edges {
          node {
            guest
            gender
          }
        }
      }
    }
  `);

  // TODO: Find a more efficient way to do this without 3D arrays
  const uniqueGuests = _.uniqWith(
    // Create a 3D array with a "tuple" for each guest and their gender, for each episode
    // Returns [..., [["Michael Malice", "M"], ["Yaron Brook", "M"]], ..., [["Elon Musk", "M"]], ...]
    data.allEpisodesJson.edges
      .map(({ node: { guest, gender } }) =>
        _.zip(guest.split(' | '), gender.split(' | '))
      )
      // Flatten the returned array with a default depth of 1
      .flat(),
    // Get unique "tuples" only
    _.isEqual
  );

  const numGuests = uniqueGuests.length;
  const numMale = uniqueGuests.filter((item) => item[1] === 'M').length;
  const numFemale = uniqueGuests.filter((item) => item[1] === 'F').length;
  const malePercentage = ((numMale / numGuests) * 100).toFixed(2);
  const femalePercentage = ((numFemale / numGuests) * 100).toFixed(2);

  // TODO: Update for guests who identify as transgender or non-binary; currently there are none
  const chartData = {
    labels: ['Male', 'Female'],
    datasets: [
      {
        data: [numMale, numFemale],
        backgroundColor: ['#36b9b7', '#3b85f2', '#3bfaf2'],
        borderWidth: 2,
        hoverOffset: 6,
      },
    ],
  };

  const chartOptions = {
    layout: {
      padding: 10,
    },
    plugins: {
      legend: {
        labels: {
          color: '#d1d5db',
        },
      },
    },
  };

  return (
    <div>
      <h3 className="text-2xl">Guest gender ratio</h3>
      <p>
        Out of <span className="text-hl">{numGuests}</span> guests that have
        appeared on the show,{' '}
        <span className="text-hl">
          {numMale} ({malePercentage}%)
        </span>{' '}
        are male and{' '}
        <span className="text-hl">
          {numFemale} ({femalePercentage}%)
        </span>{' '}
        are female.
      </p>
      <div className="mt-5 border border-gray-700 hover:border-gray-600 shadow-2xl rounded-md p-5 max-w-sm">
        <Doughnut data={chartData} options={chartOptions} />
      </div>
    </div>
  );
}
